import { useEffect, useState } from 'react';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';
import { getOfficeById } from '../../offices/services/offices.service';

/**
 * The office's name, for the editor's header.
 *
 * Only the id is in the route, and showing a UUID above a floorplan tells an admin nothing
 * about which building they are editing. Falls back to empty rather than to the id: a blank
 * header while it loads is better than a UUID that flashes and disappears.
 */
export const useOfficeName = (officeId: string | undefined): string => {
  const keycloak = useKeycloak();
  const [name, setName] = useState('');

  useEffect(() => {
    if (!officeId) {
      return undefined;
    }

    let active = true;

    getOfficeById(officeId, keycloak)
      .then((office) => {
        if (active && office?.name) {
          setName(office.name);
        }
      })
      .catch(() => {
        // The editor works perfectly well without a name in its header; failing to load one
        // is not a reason to interrupt the admin.
      });

    return () => {
      active = false;
    };
  }, [officeId, keycloak]);

  return name;
};

export default useOfficeName;
